export default __webpack_public_path__ + "static/media/1194.11598ab2.png";